import React, { useState } from 'react';

export const Navbar = ({ navVis, menu, setMenu }) => {
  // Added "Games" after "Reviews"
  const navItems = ["About", "How we work", "Services", "Build With Us", "Team", "Reviews","Apps", "Arcade", "Contact"];

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  // Helper to handle the external redirect for Games
  const getHref = (item) => {
    if (item === "Arcade") return "https://arcade.nismaystudios.in";
    return `#${item.toLowerCase().replace(/\s+/g, "-")}`;
  };

  return (
    <>
      <nav className={navVis ? "" : "hidden"}>
        <div className="nbrand" onClick={scrollToTop}>
          Nismay <em>Studios</em>
        </div>
        <ul className="nlinks">
          {navItems.map(l => (
            <li key={l}>
              <a href={getHref(l)}>{l}</a>
            </li>
          ))}
        </ul>
        <button
          className={`ntog${menu ? " open" : ""}`}
          onClick={() => setMenu(o => !o)}
          aria-label="Menu"
        >
          <span/><span/><span/>
        </button>
      </nav>
      <div className={`nmob${menu ? " open" : ""}`}>
        {navItems.map(l => (
          <a key={l} href={getHref(l)} onClick={() => setMenu(false)}>
            {l}
          </a>
        ))}
      </div>
    </>
  );
};